<template>
  <div class="table-container">
    <h3 @click="toggleTable" class="table-title">
      Hunting Draw Points
      
      <span class="toggle-icon" >
        <i :class="[tableIsCollapsed ? 'mdi mdi-chevron-up float-right' : 'mdi mdi-chevron-down float-right']"></i>
      </span>
    </h3>

    <div v-if="this.tableIsCollapsed">
      <!-- Show premium upgrade message if user doesn't have active subscription -->
      <div v-if="!hasActiveSubscription" class="premium-upgrade-section">
        <table class="table">
          <thead>
            <tr>
              <th>Species</th>
              <th>Next Eligible Year</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
            <tr class="empty-row">
              <td colspan="3" class="text-center">
                <div class="upgrade-message">
                  <i class="mdi mdi-crown premium-icon"></i>
                  <h5 class="mb-2">Upgrade to Premium to Save Your Draw Points</h5>
                  <p class="mb-3">Save your Utah preference points once and see your odds for every hunt, all in one place.</p>
                  <button class="btn btn-primary" @click="showPremiumUpgrade">
                    <i class="mdi mdi-crown me-2"></i>
                    Upgrade to Premium
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Show actual data if user has active subscription -->
      <table v-else class="table">
        <thead>
          <tr>
            <th>Species</th>
            <th>Next Eligible Year</th>
            <th>Points</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="(item, index) in data.filter(item => !item.ineligibleReason)" 
            :key="item.id"
            @click="handleRowClick(item)"
            class="clickable-row"
          >
            <td>{{ item.species }}</td>
            <td>{{ displayYear(item.nextEligible) }}</td>
            <td>{{ item.points }}</td>
          </tr>
        </tbody>
      </table>

      <div v-if="hasActiveSubscription" class="text-end mt-2">
        <button class="btn btn-outline-primary btn-sm" @click="$emit('editPoints')">
          <i class="mdi mdi-pencil me-1"></i>
          Edit points
        </button>
      </div>
    </div>

    <!-- Premium Upgrade Modal -->
    <PremiumUpgrade 
      v-if="showUpgradeModal" 
      @close="showUpgradeModal = false"
    />
  </div>
</template>

<script>
import PremiumUpgrade from './PremiumUpgrade.vue';
import { mapGetters } from 'vuex';

export default {
  name: "DrawPointsTable",
  components: {
    PremiumUpgrade,
  },
  props: {
    // Array of objects to display in the table
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return { 
      tableIsCollapsed: true,
      showUpgradeModal: false
    }
  },
  computed: {
    ...mapGetters(['hasActiveSubscription']),
  },
  methods: {
    toggleTable() {
      this.tableIsCollapsed = !this.tableIsCollapsed;
    },
    handleRowClick(item) {
      this.$emit('row-click', item);
    },
    showPremiumUpgrade() {
      this.showUpgradeModal = true;
    },
    // Manually entered rows have no next eligible year, which the API sends as "0".
    displayYear(year) {
      return year && year !== '0' && year !== 'null' ? year : '';
    }
  }
};
</script>

<style scoped>
.table-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.table-title {
  text-align: center;
  margin-bottom: 15px;
  font-weight: bold;
  font-size: 1.5rem;
  color: #333;
  cursor: pointer;
  background-color: lig;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table thead {
  background-color: lightblue;
  color: black;
}

.table th,
.table td {
  text-align: left;
  padding: 10px;
  border: 1px solid #ddd;
}

.table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.table tbody tr:hover {
  background-color: #e9ecef;
  cursor: pointer;
}

.clickable-row {
  transition: background-color 0.2s ease;
}

.premium-upgrade-section .empty-row {
  background-color: #f8f9fa !important;
}

.premium-upgrade-section .empty-row:hover {
  background-color: #f8f9fa !important;
  cursor: default;
}

.upgrade-message {
  padding: 2rem 1rem;
  text-align: center;
}

.premium-icon {
  font-size: 3rem;
  color: #ffd700;
  margin-bottom: 1rem;
}

.upgrade-message h5 {
  color: #333;
  font-weight: bold;
}

.upgrade-message p {
  color: #666;
  margin-bottom: 1.5rem;
}

.upgrade-message .btn {
  font-weight: bold;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.upgrade-message .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
</style>
